import React from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from '../../actions/adminActions';
import { actions as accountActions } from '../../actions/accountActions';
import * as types from '../../constants/actionTypes';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import Card from '../Common/Card';
import Button from '../Common/Button';
import Drawer from '../Common/Drawer/Drawer';
import AdminProfileForm from './AdminProfileForm';
import Notification from '../Common/Notification';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';

export class AdminUsersCard extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.newUser = {
            id: 0,
            firstName: '',
            lastName: '',
            userName: '',
            email: '',
            roleId: 0,
            isActive: true
        };

        this.state = {
            userId: 0,
            user: this.newUser,
            isFormValid: true,
            adminRoles: [],
            drawerOpen: false,
            isLoadingCard: true,
            isLoadingForm: false
        };
    }

    componentDidMount() {
        this.loadFilters();
    }

    onUserChange = (id) => {
        this.setState({ userId: id });
    }

    componentDidUpdate(prevProps) {
        if (this.props.adminUsers.length > 0 && this.props.adminUsers !== prevProps.adminUsers) {
            this.setState({ userId: this.props.adminUsers[0].id });
        }
    }

    loadFilters = async () => {
        try {
            this.setState({ isLoadingCard: true });

            this.props.actions.loadAdminUsers()
            const filters = await this.props.actions.getAdminProfileFilters();

            if (filters.type === types.LOAD_ADMIN_FILTERS_SUCCESS) {
                this.setState({ adminRoles: filters.payload.roles });
            } else if (filters.type === types.LOAD_ADMIN_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", filters.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoadingCard: false });
        }
    }

    onEdit = async () => {
        if (!this.state.userId > 0) {
            Notification("error", "Error", "You must select an Admin to Edit");
            return;
        }

        try {
            this.setState({ isLoadingForm: true, drawerOpen: true });
            const admin = await this.props.actions.getAdminProfile(this.state.userId);

            if (admin.type === types.LOAD_ADMIN_SUCCESS) {
                this.setState({ user: admin.payload });
            } else if (admin.type === types.LOAD_ADMIN_FAILURE) {
                this.setState({ drawerOpen: false });
                Notification("error", "An Error Occurred", admin.payload.message);
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error)
        } finally {
            this.setState({ isLoadingForm: false });
        }
    }

    onAddNew = async () => {
        try {
            this.setState({ isLoadingForm: true, drawerOpen: true });
            const filters = await this.props.actions.getAdminProfileFilters();
            if (filters.type === types.LOAD_ADMIN_FILTERS_SUCCESS) {
                this.setState({ adminRoles: filters.payload.roles, user: this.newUser })
            } else if (filters.type === types.LOAD_ADMIN_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", filters.payload.message);
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error)
        } finally {
            this.setState({ isLoadingForm: false });
        }

    }

    onFormChange = (name, value) => {
        this.setState({ user: { ...this.state.user, [name]: value } });
    }

    onCancel = () => {
        this.setState({ isFormValid: true, drawerOpen: false });
    }

    validateForm = () => {
        if (this.state.user.firstName.trim().length > 1
            && this.state.user.lastName.trim().length > 1
            && this.state.user.userName.trim().length > 1
            && this.state.user.email.trim().length > 1
            && this.state.user.roleId > 0
        ) {
            return true;
        }

        return false;
    }

    onSave = async () => {
        try {
            if (this.validateForm()) {
                this.setState({ isFormValid: true, isLoadingForm: true });
                const result = await this.props.actions.saveAdminProfile(this.state.user);
                if (result.type === types.CREATE_ADMIN_SUCCESS || result.type === types.UPDATE_ADMIN_SUCCESS) {
                    Notification("success", "Success", "Admin saved successfully");
                    this.onCancel();
                    this.props.actions.loadAdminUsers();
                } else if (result.type === types.CREATE_ADMIN_FAILURE || result.type === types.UPDATE_ADMIN_FAILURE) {
                    Notification("error", "Error", result.payload.message);
                }
            } else {
                this.setState({ isFormValid: false });
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoadingForm: false });
        }
    }

    sendForgotPasswordEmail = async () => {
        if (this.state.user.userName.trim().length < 1) {
            this.setState({ isFormValid: false });
            return;
        }

        try {
            this.setState({ isLoadingForm: true });
            await this.props.accountActions.forgotPassword(this.state.user.userName.trim());
            Notification("success", "Success", "Forgot Password Email has been sent");
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoadingForm: false });
        }
    }

    render() {
        return (
            <div>
                <Card title="Admin Users">
                    <LoadingIndicator isLoading={this.state.isLoadingCard}>
                        <div className="row">
                            <div className="col-sm-12 col-md-9">
                                <div>
                                    <MultiSelectBox 
                                        name="user" 
                                        label="Admin Users" 
                                        options={this.props.adminUsers} 
                                        idField="id" 
                                        valueField="name" 
                                        onChange={this.onUserChange} 
                                        defaultValue={null} 
                                        selectedValues={this.state.userId.toString()}
                                        isMulti={false}
                                    />
                                </div>
                            </div>
                            <div className="subscription-buttons">
                                <div className="btn-group">
                                    <Button name="edit-admin" type="" text="Edit" iconName="pencil-alt" onClick={this.onEdit} />
                                </div>
                                <div className="btn-group">
                                    <Button name="add-admin" type="" text="Add" iconName="plus-square" onClick={this.onAddNew} />
                                </div>
                            </div>
                        </div>
                    </LoadingIndicator>
                </Card>
                {this.state.drawerOpen ?
                    <Drawer isWide={false} title="Admin User" onSaveClick={this.onSave} onCancelClick={this.onCancel}>
                        <LoadingIndicator isLoading={this.state.isLoadingForm}>
                            <AdminProfileForm loggedInUserId={this.props.currentUserId}
                                user={this.state.user}
                                adminRoles={this.state.adminRoles}
                                isFormValid={this.state.isFormValid}
                                onFormChange={this.onFormChange}
                                sendForgotPasswordEmail={this.sendForgotPasswordEmail}
                            />
                        </LoadingIndicator>
                    </Drawer>                
                :
                ""
                }

            </div>
        )
    }
}

AdminUsersCard.propTypes = {
    adminUsers: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
    accountActions: PropTypes.object.isRequired,
    currentUserId: PropTypes.number.isRequired
};

function mapStateToProps(state) {
    return {
        adminUsers: state.user.adminUsers,
        currentUserId: state.user.id
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
        accountActions: bindActionCreators(accountActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminUsersCard);
